/**
 * Map a subcategory's index (0..total-1) to an opacity (1.0 → 0.35),
 * so subcategories rendered in amount-desc order get progressively
 * lighter shades of the parent category color.
 */
export function subcategoryShade(index: number, total: number): number {
  if (total <= 1) return 1
  return 1 - (index / (total - 1)) * 0.65
}
